export default __webpack_public_path__ + "static/media/photo6.ef90c920.jpg";